( function ($) {
	/**
	 * Inject + edit member information in popup modal
	 */
	$( '.options .edit' ).on( 'click', function(e) {
		e.preventDefault();

		UIkit.dropdown( $( this ).closest( '.uk-dropdown' ) ).hide( false );

		let member 				= $( this ).closest( 'tr' );
		let cPKey				  = member.find( '.cpkey' ).text();
		let firstName 		= member.find( '.fname' ).text();
		let lastName 			= member.find( '.lname' ).text();
		let email 				= member.find( '.email' ).text();
		let phone 				= member.find( '.phone' ).text();
		let access 				= member.find( '.access' ).text();
		let region 			  = member.find( '.region' ).text(); // For region text
		let accountStatus = member.find( '.account-status' ).text(); // For region text
		let regionVal 		= member.find( '.regionid' ).text(); // For region id
		let orderNotice 	= member.find( '.order' ).length > 0 ? true : false; 
		let accpayNotice  = member.find( '.accounting' ).length > 0 ? true : false;
		let generalNotice = member.find( '.general' ).length > 0 ? true : false;
		let dailyHTML 		= member.find( '.daily-limit' ).text(); 
		let dailyLimit 		= dailyHTML.replace( /\D/g, '' );
		let weeklyHTML 		= member.find( '.weekly-limit' ).text(); 
		let weeklyLimit 	= weeklyHTML.replace( /\D/g, '' );
		let orderHTML 		= member.find( '.order-limit' ).text(); 
		let orderLimit 		= orderHTML.replace( /\D/g, '' );

		$( '#fname' ).val( firstName );
		$( '#lname' ).val( lastName );
		$( '#visible_email' ).val( email );
		$( '#email' ).val( email );
		$( '#phonenum' ).val( phone );

		if( access ) {
			$( '#pm_btn_role' ).text( access ).css( 'color', '#000' ); // apply value to button label
		}

		if( region ) {
			$( '#pm_btn_region' ).text( region ).css( 'color', '#000' ); // apply value to button label
		}

		else { // If user has no region set put placeholder back
			$( '#pm_btn_region' ).text( 'Select region' ).css( 'color', '#c2c2c2' ); 
		}

		$( '#pm_role' ).val( access );	// apply value to json data
		$( '#pm_region' ).val( region );	// apply text value to json data
		$( '#pm_region_id' ).val( regionVal );	// apply id value to json data
		$( '#orderRelatededitUser' ).prop( "checked", orderNotice );
		$( '#accPayeditUser' ).prop( "checked", accpayNotice );
		$( '#genNoticeeditUser' ).prop( "checked", generalNotice );
		$( '#dlimit' ).val( dailyLimit );
		$( '#wlimit' ).val( weeklyLimit );
		$( '#olimit' ).val( orderLimit );
		$( '#pm_as' ).val( accountStatus );
		$( '#pm_cid' ).val( cPKey );

		// calls from chips.js
		notificationChips();
	} );

	$( '.notification-checkbox' ).on( 'change', function() {
		notificationChips();
	} );
} )( jQuery );
